import TYPE from 'src/redux/actions/TYPE';

const initialState = {
  disableUS: []
};

const website = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.GET_LIST_WEBSITE_DISABLE_US_SUCCESS:
      return {
        ...state,
        disableUS: action.payload
      };

    default:
      return { ...state };
  }
};

export default website;
